module.exports = __webpack_public_path__ + "img/mobileTerminalBG.2d816a59.png";